interface ManagerRating {
  id?: string;
  evaluation?: string | null;
  rating?: number | string | null;
}

interface ManagerRattingsProps {
  ratings: ManagerRating[];
}

export default function ManagerRattings({ ratings }: ManagerRattingsProps) {
  if (!ratings || ratings.length === 0) return null;

  return (
    <>
      {ratings.map((mr, mrIdx) => (
        <div key={mr.id || mrIdx} className="grid grid-cols-2 gap-6 !mt-6">
          <div>
            <label className="text-theme-gray-400 text-xs mb-1.5 block font-semibold tracking-wider">
              Line Manager - {mrIdx + 1} Evaluation
            </label>
            <div className="bg-theme-slate-800 border border-white/30 rounded-lg px-4 py-3 text-white min-h-[80px] whitespace-pre-wrap text-sm">
              {mr.evaluation || "No evaluation provided"}
            </div>
          </div>
          <div>
            <label className="text-theme-gray-400 text-xs mb-1.5 block font-semibold tracking-wider">
              Rating Scale (1-5)
            </label>
            <div className="bg-theme-slate-800 border border-white/30 rounded-lg px-4 py-2.5 text-white text-sm">
              {mr.rating || "0"}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
